import axios from 'axios';
import { config } from '../config';

const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((reqConfig) => {
  reqConfig.baseURL = `${config.apiUrl}/api`;
  return reqConfig;
});

export interface RegisterRequest {
  siteNodeId: string;
  name: string;
  email: string;
  phone: string;
  password: string;
}

export interface LoginRequest {
  siteNodeId: string;
  email: string;
  password: string;
}

export interface GoogleLoginRequest {
  siteNodeId: string;
  idToken: string;
}

export interface CustomerInfo {
  id: string;
  siteNodeId: string;
  name: string;
  email: string;
  phone: string;
}

export interface CustomerLoginResponse {
  token: string;
  customer: CustomerInfo;
}

export const customerAuthApi = {
  async registerCustomer(request: RegisterRequest): Promise<CustomerLoginResponse> {
    const response = await apiClient.post('/customer-auth/register', request);
    return response.data;
  },

  async loginCustomer(request: LoginRequest): Promise<CustomerLoginResponse> {
    const response = await apiClient.post('/customer-auth/login', request);
    return response.data;
  },

  async googleLogin(request: GoogleLoginRequest): Promise<CustomerLoginResponse> {
    const response = await apiClient.post('/customer-auth/google', request);
    return response.data;
  },

  async refreshToken(token: string): Promise<CustomerLoginResponse> {
    const response = await apiClient.post('/customer-auth/refresh', { token });
    return response.data;
  },

  async getCurrentCustomer(token: string): Promise<CustomerInfo> {
    const response = await apiClient.get('/customer-auth/me', {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  },
};
